import { useRef } from 'react';
import useFocus from '../utility/useFocus';
import useInitialData from './useInitialData';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';

export default function useAppFocus() {
  const { data, refresh } = useInitialData();

  const { slug } = useParams();

  const { franchise } = data;
  const { cached_order } = useSelector((state: StoreInterface) => state.order);

  const cachedOrderRef = useRef(cached_order);
  cachedOrderRef.current = cached_order;

  const franchiseRef = useRef(franchise);
  franchiseRef.current = franchise;

  const slugRef = useRef(slug);
  slugRef.current = slug;

  useFocus(
    () => setTimeout(() => onFocus(), 50),
    () => null,
  );

  async function onFocus(): Promise<void> {
    if (!slugRef.current && franchiseRef.current?.has_multiple_companies) {
      return;
    }

    await refresh(slugRef.current, true);
  }
}
